export const styles = {
	root: {
		display: 'flex',
		flexGrow: 1,
		paddingTop: 4
	},
	title: {
		marginBottom: 2
	},
	paper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: 200,
		position: 'relative',

		'& > .MuiTypography-root': {
			marginTop: 0
		}
	},
	fabProgress: {
		color: 'primary.main',
		zIndex: 1
	},
	centered: {
		height: '100vh',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	bottomOffset: {
		marginBottom: 2
	}
};
